export const toCurrency = (value: number) => {
  return `${value}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
